jQuery( document ).ready(
	function ( $ ) {

		'use strict';

		let LocationBar = require('./location-bar');

		$.extend( $.expr[':'], {
			'containsNC': function ( elem, i, match, array ) {
				return ( elem.textContent || elem.innerText || '' ).toLowerCase().indexOf( ( match[3] || '' ).toLowerCase() ) >= 0;
			}
		} );

		var $filters = $( '.trailer-filters' );

		// Remove parent categories from form submission if they have sub-categories selected
		var uncheckParents = function () {
			$filters.find( 'input[type="checkbox"]' ).each( function () {
				var $this         = $( this );
				var $childFilters = $this.parent().next( 'ul' );

				if ( $childFilters.length > 0 ) {
					if ( $childFilters.find( 'input[type="checkbox"]:checked' ).length > 0 ) {
						if ( ! $this.hasClass( 'checked' ) ) {
							$this.addClass( 'checked' );
						}

						$this.prop( 'checked', false );
					}
				}
			} );
		};

		// Make parent categories appear checked when checking sub-category,
		// alternatively uncheck parent category if all sub-categories are unchecked
		var toggleParent = function ( $element ) {
			var $filterGroup  = $element.closest( 'ul' );
			var $parentFilter = $filterGroup.prev().find( 'input[type="checkbox"]' );

			if ( $parentFilter.length > 0 ) {
				if ( $filterGroup.find( 'input[type="checkbox"]:checked' ).length === 0 ) {
					$parentFilter.removeClass( 'checked' );
				} else {
					if ( ! $parentFilter.hasClass( 'checked' ) ) {
						$parentFilter.addClass( 'checked' );
					}
				}
			}
		};

		// Hide other category sections if a filter is selected,
		// show them all if the last filter is unchecked
		var toggleUncheckedCategories = function ( $element ) {
			var $selectedSection = $element.closest( 'section' );
			var sectionSiblings = $selectedSection.siblings( 'section' );

			if ( $selectedSection.find( 'input[type="checkbox"]:checked' ).length > 0 ) {
				sectionSiblings.addClass( 'hidden' );
			} else {
				sectionSiblings.removeClass( 'hidden' );
			}
		};

		var checkedFilters = $filters.find( 'input[type="checkbox"]:checked' );

		// Hide non-relevant filter sections on load
		toggleUncheckedCategories( $( checkedFilters.get(0) ) );

		// Make sure all parent categories appear checked on load
		checkedFilters.each( function () {
			toggleParent( $( this ) );
		} );

		$filters
			.on( 'change keyup', 'input[type=text]', function () {

				var searchterm = $( this ).val();
				var $categoryList = $( this ).siblings( 'ul' );
				var $match = $categoryList.find( 'li:containsNC("' + searchterm + '")' );

				$categoryList.find( 'li' ).addClass( 'inactive' ).find( 'input[type=checkbox]' ).attr( 'disabled', true );

				if ( $match.length > 0 ) {
					$match.removeClass( 'inactive' ).find( 'input[type=checkbox]' ).removeAttr( 'disabled' );
				}

			} )
			.on( 'change', 'input[type="checkbox"]', function () {
				var $this         = $( this );
				var $childFilters = $this.parent().next( 'ul' );

				if ( $childFilters.length > 0 ) {
					var checked = true;

					if ( $this.hasClass( 'checked' ) ) {
						$this.removeClass( 'checked' );
						checked = false;
					} else {
						$this.addClass( 'checked' );
					}

					// If selected checkbox category has sub-categories, toggle them based on parent checked status
					$childFilters.find( 'input[type="checkbox"]' ).prop( 'checked', checked );

					$this.prop( 'checked', false );
				}

				toggleParent( $this );
				toggleUncheckedCategories( $this );

				$( '.trailer-filters form' ).submit();
			} )
			.on( 'click', '.select-all', function ( event ) {
				event.preventDefault();

				$( this ).next( 'ul' ).find( 'input[type="checkbox"]' ).prop( 'checked', true );

				uncheckParents();

				$( '.trailer-filters form' ).submit();
			} );

		if ( window.location.href.indexOf( '?' ) > - 1 ) {
			var $button = $( '.trailer-filters-button' );

			$filters.next().addClass( 'filters-applied' );
			$button
				.addClass( 'showing' )
				.children( 'span.fa' )
				.removeClass( 'fa-plus' )
				.addClass( 'fa-minus' );

		}

		$( '.trailer-filters-button' ).on( 'click', function ( event ) {
			event.preventDefault();

			var $this = $( this );
			var $children = $this.children( 'span.fa' );
			var $productGrid = $('#product-grid');

			if ( ! $this.hasClass( 'showing' ) ) {
				$filters.animate( {width: 'toggle'}, 350 );
				$productGrid.addClass( 'filters-applied' );
				$children.removeClass( 'fa-plus' ).addClass( 'fa-minus' );
				$this.addClass( 'showing' );
			} else {
				$filters.animate( {width: 'toggle'}, 350 );
				$productGrid.removeClass( 'filters-applied' );
				$children.removeClass( 'fa-minus' ).addClass( 'fa-plus' );
				$this.removeClass( 'showing' );
			}

		} );

		$( '.filter__title' ).on( 'click', function ( event ) {
			event.preventDefault();

			var $this = $( this );
			var $icon = $this.find( 'span.fa' );

			if ( $this.hasClass( 'showing' ) ) {
				$this.removeClass( 'showing' );
				$icon.removeClass( 'fa-chevron-up' ).addClass( 'fa-chevron-down' );
				$this.next( 'fieldset' ).slideUp();
			} else {
				$this.addClass( 'showing' );
				$icon.removeClass( 'fa-chevron-down' ).addClass( 'fa-chevron-up' );
				$this.next( 'fieldset' ).slideDown();
			}

		} );

		var $filterForm = $( '#filter-form' );

		$( 'select[name="sorting"]' ).on( 'change', function () {

			$filterForm.submit();

		} );

		if ( $filterForm.length > 0 ) {

			//  Location Manager (https://github.com/KidkArolis/location-bar)
			var locationBar      = new LocationBar();
			var $filterWrapper   = $filterForm.closest( '[data-page-wrapper]' );
			var $resultContainer = $filterWrapper.find( '[data-results-holder]' );
			var $input           = $filterForm.find( 'input[type="checkbox"]' );

			locationBar.start( {
				pushState: true
			} );

			//  Ajax the changed URL
			locationBar.onChange( function ( path ) {

				//  Show loader
				$filterWrapper.find( '.loader-wrapper' ).show();

				$.ajax( {
					url: '/' + path,
					cache: false,
					dataType: 'json',
					method: 'post',
					data: {
						filter: 1
					}
				} ).done( function ( data ) {

					//  Add items to DOM
					$resultContainer.html( data.results );

					//  Hide loader
					$filterWrapper.find( '.loader-wrapper' ).hide();

				} ).fail( function () {
					window.location = url;
				} );
			} );

			$filterForm.on( 'submit', function ( ev ) {
				ev.preventDefault();

				var formData = $( this ).serialize();
				var pathname = window.location.pathname;
				var prefix   = '';
				var sorting  = $( '#filter-sorting' ).find( 'select' ).val();

				if ( formData || sorting ) {
					prefix = '?';
				}

				if ( sorting ) {
					sorting = 'sorting=' + sorting;
				}

				if ( formData && sorting ) {
					sorting = '&' + sorting;
				}

				locationBar.update( pathname + prefix + formData + sorting, {trigger: true} );
			} );

			//  Handle filter
			$input.on( 'change', function () {
				$filterForm.submit();
			} );

		}

	} );
